import React from 'react';
import { Warning, ArrowForward } from '@mui/icons-material';

//  Reuse the Error page styling so the conflict screen matches the rest of the app without
//  a second stylesheet to maintain.
import '../Error/index.css';
//  Adds edge padding and a width-capped, centred content column on top of the Error styles.
import './index.css';

//  TabConflict
//  Shown instead of the app when another ED3N tab in this browser is already active. It is
//  a dead-end by design: the whole point is to funnel the user back to the one live tab so
//  the two tabs cannot race the single-use SAMS refresh token. Reloading re-runs the tab
//  claim, so if the other tab has since been closed this page lets the user back in.
export default function TabConflict() {
    return (
        <div className='errorContainer tabConflictContainer' role='main'>
            <div className='errorBox'>
                <div className='errorTitle'>
                    <h1>
                        <Warning style={{ fontSize: '3.5rem', marginTop: '-3px', verticalAlign: 'middle' }} /> ED3N is already open
                    </h1>
                </div>
                <div className='errorBody'>
                    <div className='errorMessage'>
                        <span>ED3N is already open in another tab or window of this browser.</span>
                        {' - '}
                        <span>Please switch to the tab where ED3N is already open and continue your work there.</span>
                    </div>
                    <div className='errorLoginMessage'>
                        <div className='loginWrapper'>
                            <div>
                                If you have closed the other tab, reload this page to continue:
                            </div>
                            <div className='linkWrapper'>
                                <button
                                    type='button'
                                    className='loginLink'
                                    aria-label='reload ED3N'
                                    onClick={() => window.location.reload()}
                                    style={{ cursor: 'pointer', font: 'inherit' }}
                                >
                                    <ArrowForward fontSize='medium' style={{ verticalAlign: 'middle' }} /> Reload ED3N
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
